import React from "react";

function PlusButton2({ caption, onButtonClick }) {
  return (
    <div className="plus-button-2__container" onClick={onButtonClick}>
      <span>{caption}</span>
    </div>
  );
}

export default PlusButton2;
